import type { ReverseGeocode } from "../api/GeoDataAPI";

const KEY = "bh_last_geo";

/** Remembers the user's last-selected location so pickers can offer it back. */
export function saveLastLocation(chain: ReverseGeocode): void {
    try {
        if (chain.country) localStorage.setItem(KEY, JSON.stringify(chain));
    } catch { /* storage unavailable — fine */ }
}

export function loadLastLocation(): ReverseGeocode | null {
    try {
        const s = localStorage.getItem(KEY);
        return s ? (JSON.parse(s) as ReverseGeocode) : null;
    } catch {
        return null;
    }
}

/** Deepest name in a chain, for button labels ("↩ Houston"). */
export function deepestName(c: ReverseGeocode): string {
    return c.city?.name ?? c.admin2?.name ?? c.admin1?.name ?? c.country?.name ?? "";
}

/** Browser position as a promise; rejects with message "denied" when refused. */
export function getBrowserPosition(): Promise<{ lat: number; lon: number }> {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error("unsupported"));
            return;
        }
        navigator.geolocation.getCurrentPosition(
            (p) => resolve({ lat: p.coords.latitude, lon: p.coords.longitude }),
            (e) => reject(new Error(e.code === 1 ? "denied" : "unavailable")),
            { timeout: 10000, maximumAge: 300000 }
        );
    });
}